<template>
  <div class="agent-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <el-input
            v-model.trim="filters.phone"
            placeholder="手机号"
            clearable
            style="width: 160px"
            @keyup.enter.native="handleSearch"
          />
          <el-input
            v-model.trim="filters.username"
            placeholder="后台账号"
            clearable
            style="width: 160px"
            @keyup.enter.native="handleSearch"
          />
          <el-select v-model="filters.status" placeholder="状态" clearable style="width: 120px">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <div class="filter-bar__spacer" />
          <el-button type="primary" icon="el-icon-plus" @click="handleCreate">新建代理</el-button>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && list.length === 0" description="暂无代理" />

      <template v-else>
        <el-table :data="list" border stripe v-loading="loading" row-key="id">
          <el-table-column prop="userId" label="用户ID" width="90" align="center" />
          <el-table-column prop="phone" label="手机号" min-width="120" />
          <el-table-column prop="nickname" label="昵称" min-width="100" />
          <el-table-column label="后台账号" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.hasAdminAccount">{{ scope.row.adminUsername }}</span>
              <span v-else class="muted">未开通</span>
            </template>
          </el-table-column>
          <el-table-column prop="userKeepRate" label="激励%" width="80" align="center" />
          <el-table-column prop="directRate" label="直推%" width="80" align="center" />
          <el-table-column prop="indirectRate" label="间接%" width="80" align="center" />
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
              <el-tag v-else type="info" size="small">停用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" min-width="160" />
          <el-table-column label="操作" width="220" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="openResetAccount(scope.row)">重置账号</el-button>
              <el-button
                v-if="scope.row.status === 1"
                type="text"
                size="small"
                class="danger-text"
                @click="handleDisable(scope.row)"
              >停用</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="p => { pagination.page = p; fetchList() }"
            @size-change="s => { pagination.pageSize = s; pagination.page = 1; fetchList() }"
          />
        </div>
      </template>
    </el-card>

    <el-dialog
      title="新建代理"
      :visible.sync="createVisible"
      width="620px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="createFormRef" :model="createForm" :rules="createRules" label-width="140px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="createForm.phone" maxlength="11" placeholder="未注册的手机号" />
        </el-form-item>
        <el-form-item label="后台账号" prop="username">
          <el-input v-model.trim="createForm.username" maxlength="16" placeholder="登录用户名" />
        </el-form-item>
        <el-form-item label="后台密码" prop="password">
          <el-input v-model="createForm.password" type="password" show-password maxlength="32" placeholder="6-32位密码" />
        </el-form-item>
        <el-form-item label="激励用户比例" prop="userKeepRate">
          <el-input-number v-model="createForm.userKeepRate" :min="0" :max="100" /> %
        </el-form-item>
        <el-form-item label="推广统一比例" prop="promoteRate">
          <el-input-number v-model="createForm.promoteRate" :min="0" :max="100" /> %
        </el-form-item>
        <el-form-item label="本人激励广告位" prop="rewardMediaId">
          <el-input v-model.trim="createForm.rewardMediaId" placeholder="代理本人使用的 reward_media_id" />
        </el-form-item>
        <el-form-item label="本人回调密钥" prop="callbackKey">
          <el-input v-model.trim="createForm.callbackKey" placeholder="本人激励广告位安全密钥" />
        </el-form-item>
        <el-form-item label="推广激励广告位" prop="promoteRewardMediaId">
          <el-input v-model.trim="createForm.promoteRewardMediaId" placeholder="可选；空则直邀/间邀不下发该位" />
        </el-form-item>
        <el-form-item label="推广回调密钥" prop="promoteCallbackKey">
          <el-input v-model.trim="createForm.promoteCallbackKey" placeholder="可选；与推广位配套，空不回落全局" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="createForm.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible = false">取消</el-button>
        <el-button type="primary" :loading="createSubmitting" @click="submitCreate">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑代理配置"
      :visible.sync="editVisible"
      width="620px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="editFormRef" :model="editForm" :rules="profileRules" label-width="140px" v-loading="editLoading">
        <el-form-item label="用户">
          <el-input :value="editLabel" disabled />
        </el-form-item>
        <el-form-item label="激励用户比例" prop="userKeepRate">
          <el-input-number v-model="editForm.userKeepRate" :min="0" :max="100" /> %
        </el-form-item>
        <el-form-item label="推广统一比例" prop="promoteRate">
          <el-input-number v-model="editForm.promoteRate" :min="0" :max="100" /> %
        </el-form-item>
        <el-form-item label="本人激励广告位" prop="rewardMediaId">
          <el-input v-model.trim="editForm.rewardMediaId" placeholder="代理本人使用的 reward_media_id" />
        </el-form-item>
        <el-form-item label="本人回调密钥" prop="callbackKey">
          <el-input v-model.trim="editForm.callbackKey" placeholder="本人激励广告位安全密钥" />
        </el-form-item>
        <el-form-item label="推广激励广告位" prop="promoteRewardMediaId">
          <el-input v-model.trim="editForm.promoteRewardMediaId" placeholder="可选；空则直邀/间邀不下发该位" />
        </el-form-item>
        <el-form-item label="推广回调密钥" prop="promoteCallbackKey">
          <el-input v-model.trim="editForm.promoteCallbackKey" placeholder="可选；与推广位配套，空不回落全局" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="editForm.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editSubmitting" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="重置代理后台账号"
      :visible.sync="accountVisible"
      width="440px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="accountFormRef" :model="accountForm" :rules="accountRules" label-width="100px">
        <el-form-item label="用户">
          <el-input :value="accountLabel" disabled />
        </el-form-item>
        <el-form-item label="后台账号" prop="username">
          <el-input v-model.trim="accountForm.username" maxlength="16" placeholder="登录用户名" />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="accountForm.password" type="password" show-password maxlength="32" placeholder="6-32位密码" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="accountVisible = false">取消</el-button>
        <el-button type="primary" :loading="accountSubmitting" @click="submitAccount">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, del, getResponseMessage } from '@/utils/http.js'

const emptyCreateForm = () => ({
  phone: '',
  username: '',
  password: '',
  userKeepRate: 50,
  promoteRate: 0,
  rewardMediaId: '',
  callbackKey: '',
  promoteRewardMediaId: '',
  promoteCallbackKey: '',
  status: 1
})

const profileRules = {
  userKeepRate: [{ required: true, message: '请填写激励比例', trigger: 'blur' }],
  promoteRate: [{ required: true, message: '请填写推广统一比例', trigger: 'blur' }],
  rewardMediaId: [{ required: true, message: '请填写本人激励广告位', trigger: 'blur' }],
  callbackKey: [{ required: true, message: '请填写本人回调密钥', trigger: 'blur' }]
}

export default {
  name: 'AgentManagement',
  data() {
    return {
      loading: false,
      error: '',
      list: [],
      pagination: { page: 1, pageSize: 20, total: 0 },
      filters: { phone: '', username: '', status: '' },
      createVisible: false,
      createSubmitting: false,
      createForm: emptyCreateForm(),
      createRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        username: [{ required: true, message: '请输入后台账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 32, message: '密码长度 6-32 位', trigger: 'blur' }
        ],
        ...profileRules
      },
      profileRules,
      editVisible: false,
      editLoading: false,
      editSubmitting: false,
      editForm: {
        userId: null,
        phone: '',
        nickname: '',
        userKeepRate: 50,
        promoteRate: 0,
        rewardMediaId: '',
        callbackKey: '',
        promoteRewardMediaId: '',
        promoteCallbackKey: '',
        status: 1
      },
      accountVisible: false,
      accountSubmitting: false,
      accountUserId: null,
      accountLabel: '',
      accountForm: { username: '', password: '' },
      accountRules: {
        username: [{ required: true, message: '请输入后台账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 32, message: '密码长度 6-32 位', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    editLabel() {
      const n = this.editForm.nickname || ''
      const p = this.editForm.phone || ''
      const id = this.editForm.userId
      return `${n}${p ? ' / ' + p : ''} (ID:${id || '-'})`
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        if (this.filters.phone) params.phone = this.filters.phone
        if (this.filters.username) params.username = this.filters.username
        if (this.filters.status !== '' && this.filters.status !== null && this.filters.status !== undefined) {
          params.status = this.filters.status
        }
        const res = await get('/admin/agent/page', params)
        const data = res.data || {}
        this.list = data.records || []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.list = []
        this.error = e.message || '加载失败'
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.filters = { phone: '', username: '', status: '' }
      this.pagination.page = 1
      this.fetchList()
    },
    handleCreate() {
      this.createForm = emptyCreateForm()
      this.createVisible = true
      this.$nextTick(() => this.$refs.createFormRef && this.$refs.createFormRef.clearValidate())
    },
    submitCreate() {
      this.$refs.createFormRef.validate(async valid => {
        if (!valid) return
        this.createSubmitting = true
        try {
          await post('/admin/agent/create-full', { ...this.createForm })
          this.$message.success('代理已创建')
          this.createVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '创建失败')
        } finally {
          this.createSubmitting = false
        }
      })
    },
    openEdit(row) {
      const promoteRate = row.promoteRate != null
        ? row.promoteRate
        : (row.directRate != null ? row.directRate : row.indirectRate)
      this.editForm = {
        userId: row.userId,
        phone: row.phone || '',
        nickname: row.nickname || '',
        userKeepRate: row.userKeepRate,
        promoteRate: promoteRate == null ? 0 : promoteRate,
        rewardMediaId: row.rewardMediaId || '',
        callbackKey: row.callbackKey || '',
        promoteRewardMediaId: row.promoteRewardMediaId || '',
        promoteCallbackKey: row.promoteCallbackKey || '',
        status: row.status == null ? 1 : row.status
      }
      this.editVisible = true
      this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate())
    },
    submitEdit() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        this.editSubmitting = true
        try {
          await post('/admin/agent', {
            userId: this.editForm.userId,
            userKeepRate: this.editForm.userKeepRate,
            promoteRate: this.editForm.promoteRate,
            rewardMediaId: this.editForm.rewardMediaId,
            callbackKey: this.editForm.callbackKey,
            promoteRewardMediaId: this.editForm.promoteRewardMediaId,
            promoteCallbackKey: this.editForm.promoteCallbackKey,
            status: this.editForm.status
          })
          this.$message.success('配置已保存')
          this.editVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '保存失败')
        } finally {
          this.editSubmitting = false
        }
      })
    },
    openResetAccount(row) {
      this.accountUserId = row.userId
      this.accountLabel = `${row.nickname || ''} / ${row.phone || ''} (ID:${row.userId})`
      this.accountForm = {
        username: row.adminUsername || '',
        password: ''
      }
      this.accountVisible = true
      this.$nextTick(() => this.$refs.accountFormRef && this.$refs.accountFormRef.clearValidate())
    },
    submitAccount() {
      this.$refs.accountFormRef.validate(async valid => {
        if (!valid) return
        this.accountSubmitting = true
        try {
          await post('/admin/agent/admin-account', {
            userId: this.accountUserId,
            username: this.accountForm.username,
            password: this.accountForm.password
          })
          this.$message.success('账号已重置')
          this.accountVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '重置失败')
        } finally {
          this.accountSubmitting = false
        }
      })
    },
    async handleDisable(row) {
      try {
        await this.$confirm(`确定停用代理「${row.phone || row.userId}」吗？`, '提示', { type: 'warning' })
        await del(`/admin/agent/${row.userId}`)
        this.$message.success('已停用')
        this.fetchList()
      } catch (e) {
        if (e === 'cancel' || e === 'close') return
        this.$message.error(getResponseMessage(e) || e.message || '操作失败')
      }
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.filter-bar__spacer {
  flex: 1;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error { color: #f56c6c; margin-bottom: 12px; }
.danger-text { color: #f56c6c; }
.muted { color: #94a3b8; }
</style>
